import About from "../components/Views/About";
import Education from "../components/Views/Education";
import Intro from "../components/Views/Intro"
import Projects from "../components/Views/Projects";

export const fragments_config = {
   COLUMNS: 100,
   ROWS: 30,
   ICON_SIZE: 13,
   COLOR: "#00ff11",
   LETTER_DIM: 7,
   TEXT_FILLER: " ",
   LETTERS_MARGIN: 2,
};

export const views = [<Intro />, <About />, <Education />, <Projects />]